import { required } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode, validate } from "vee-validate"
import { mapGetters } from 'vuex';
import { watch } from 'vue';
import DialogEvaluacion from '@/components/DialogEvaluacion.vue';
setInteractionMode("eager")
extend('allRequired', {
    validate(value) {
        return value.every(item => item.asistencia !== '');
    },
    message: 'Todos los campos de asistencia deben estar completos',
});
extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
});
const meeting = {
    components: { ValidationObserver, ValidationProvider, DialogEvaluacion },
    props: ['notify'],
    data: () => ({
        coCreadoSelected: null,
        cocreadorId: null,
        rulesTextAreaDetalles: [v => v.length <= 250 || 'Max 250 characters'],
        ruleMaxCaracters: [
            v => !!v || 'Este campo es obligatorio',
            v => (v && v.length <= 250) || 'Max 250 caracteres'
        ],
        legends: [
            { icon: 'mdi-square', description: 'Recurrencia mensual', color: 'orange' },
            { icon: 'mdi-square', description: 'Recurrencia semanal', color: 'purple' },
            { icon: 'mdi-square', description: 'Recurrencia diaria', color: 'green' },
            { icon: 'mdi-square', description: 'Sin recurrencia', color: 'blue' },
            { icon: 'mdi-file-alert-outline', description: 'Con Minuta' },
            { icon: 'mdi-presentation', description: 'Con Presentacion' }
        ],
        internos: [],
        clientes: [],
        maxSize: 15 * 1024 * 1024,
        //ejemplo de minuta
        menu: false,
        menuInicio: false,
        menuInicioDetails: false,
        menuInicioReprogramar: false,
        menuInicioNuevaReunion: false,
        dialogActivity: false,
        statusMinuta: true,
        cerrar_minuta: false,
        loadingSendEncuesta: false,
        idActivity: 0,
        dateMinActividades: '',
        editActivity: false,
        dialogActResponsable: false,
        loadingMnt: false,
        loadingAddMnt: false,
        loadingHistorialasistencias: false,
        newAgendaItem: '',
        enlace: 'https://meet.google.com/eit-sgbu-cag',
        deleteEvent: false,
        EventDelete: '1',
        newActivity: {
            actividad: '',
            responsable: [],
            detalles: '',
            fechaInicio: '',
            status: ''
        },
        minuta: {
            id: null,
            nombreReunion: '',
            fechaReunion: '',
            objetivoReunion: '',
            lugar: '',
            convocados: [],
            agenda: [],
            actividades: [],
            archivos: [],
            archivosCargados: [],
            archivosCargadosAnt: [],
            convocadosHistorial: []
        },
        encuesta: {
            clientes: [],
            id_minuta: '',
            enviado_por: '',
            tipo_encuesta: 'Encuesta simple'
        },
        minutasAnteriores: [], // Lista de minutas anteriores 
        minutaSeleccionada: null, // Minuta seleccionada
        cargandoMinutas: false,
        maxFiles: 4,
        validFileTypes: [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel
            'application/vnd.openxmlformats-officedocument.presentationml.presentation' // PowerPoint
        ],
        lugares: ['Meet', 'Teams', 'Mdy Lince', 'Mdy Colonial', 'Otros'],
        convocados: ['Líder 1', 'Líder 2', 'Líder 3'],
        responsables: ['Líder 1', 'Líder 2', 'Líder 3'],
        statusOptions: [
            { text: 'Cerrado', value: 'Cerrado', color: 'green' },
            { text: 'Seguimiento', value: 'Seguimiento', color: 'yellow' },
            { text: 'Permanente', value: 'Permanente', color: 'blue' },
            { text: 'Pendiente', value: 'Pendiente', color: 'red' }
        ],
        agendaHeaders: [
            { text: 'Número', value: 'number' },
            { text: 'Agenda', value: 'item' },
            { text: 'Acciones', value: 'actions', sortable: false }
        ],
        agendaHeadersUser: [
            { text: 'Número', value: 'number' },
            { text: 'Agenda', value: 'item' }
        ],
        activityHeaders: [
            { text: 'Nº', value: 'number' },
            { text: 'Actividad', value: 'actividad' },
            { text: 'Responsable', value: 'responsable' },
            { text: 'Detalles de Compromiso', value: 'detalles' },
            { text: 'Fecha de inicio', value: 'fechaInicio' },
            { text: 'Status', value: 'status' },
            { text: 'Acciones', value: 'actions', sortable: false }
        ],
        activityHeadersUser: [
            { text: 'Nº', value: 'number' },
            { text: 'Actividad', value: 'actividad' },
            { text: 'Responsable', value: 'responsable' },
            { text: 'Detalles de Compromiso', value: 'detalles' },
            { text: 'Fecha de inicio', value: 'fechaInicio' },
            { text: 'Status', value: 'status' },
            { text: 'Acciones', value: 'actions', sortable: false }
        ],
        convocadosHeaders: [
            { text: 'Número', value: 'number' },
            { text: 'Nombre', value: 'name' },
            { text: 'Asistencia', value: 'asistencia' },
            { text: 'Representante', value: 'representante', width: '300px' }
        ],
        convocadoshistorialHeader: [
            // { text: 'Fecha', value: 'fecha' },
            // { text: 'Nombre', value: 'name' },
            // { text: 'Asistencia', value: 'asistencia' },
            // { text: 'Representante', value: 'representante' }
        ],
        archivosValidate: false,
        archivoHeaders: [
            { text: 'Nombre de Archivo', value: 'nombreArchivo', width: '680px' },
            { text: 'Archivo', value: 'url' },
            { text: 'Fecha Carga', value: 'fecha' }
        ],
        actividadesDetalleHeader: [
            { text: 'Nº', value: 'index' },
            { text: 'Fecha', value: 'fecha_compromiso' },
            { text: 'Detalle', value: 'texto', width: '400px' },
            { text: 'Acciones', value: 'acciones' }
        ],
        recursosHeaders: [
            { text: 'Nombre de Archivo', value: 'nombre', width: '680px' },
            { text: 'Archivo', value: 'url' },
            { text: 'Fecha Carga', value: 'fecha_carga' }
        ],
        loadingCalendar: false,
        asistenciaHistorial: {},
        ///////////////////
        addMeet: false,
        dialogMinuta: false,
        dialogEncuesta: false,
        startTime: null,
        endTime: null,
        startMenu: false,
        endMenu: false,
        menuDate: false,
        dateMeet: [],
        detailsMeet: null,
        selectedMeetingType: null,
        selectedAttendee: null,
        filteredLeaders: [],
        filteredClients: [],
        filteredInviteesAll: [],
        campaigns: [
            { text: 'Campaña 1', value: 'campaign1' },
            { text: 'Campaña 2', value: 'campaign2' },
            { text: 'Campaña 3', value: 'campaign3' }
        ],
        meetingTypes: [
            { text: 'Interno', value: 'interno' },
            { text: 'Cliente', value: 'cliente' }
        ],
        attendees: [],
        recurrenceOptions: [
            { text: 'No recurrente', value: 'No recurrente', color: 'blue' },
            { text: 'Diaria', value: 'Diaria', color: 'green' },
            { text: 'Semanal', value: 'Semanal', color: 'purple' },
            { text: 'Mensual', value: 'Mensual', color: 'orange' }
        ],
        recurrence_pattern: '',
        itemsHoras: [
            '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
            '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
            '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30'
        ],
        form: {
            title: '',
            dateMeet: [],
            recurrence_pattern: '',
            startTime: '',
            endTime: '',
            campana: []
        },


        focus: '',
        type: 'month',
        typeToLabel: {
            month: 'Mes',
            week: 'Semana',
            day: 'Dia',
            '4day': '4 Dias',
        },
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
        predefinedEvents: [
        ],

        fab: false,
        meetingLink: '',

        valid: false,
        newData: {
            text: '',
            bullets: []
        },
        newBullet: '',
        selectedItem: null,
        headers: [
            { text: 'ACTIVIDAD', value: 'name', width: '400px' },
            { text: 'DETALLES', value: 'custom_column' }
        ],
        items: [],
        activities: [],
        loadingActivities: false,
        activityDialog: false,
        processedDetails: [],
        showSelect: null,
        selectedActivity: {},
        asistenciaDialog: false,
        AgregarConvocadosDialog: false,
        listaConvocadosPendientes: [],
        loadingAgregarConvocadosDialog: false,
        headers: [
            { text: 'Nombre', value: 'name' },
            { text: 'Asistencia', value: 'asistencia' },
            { text: 'Representante', value: 'representante' },
            { text: 'Minuta ID', value: 'minuta_id' }
        ],
        modalCerrarMinuta: false,
        newDetailActivity: '',
        newDateDetailActivity: '',
        editDetailActivityStatus: false,
        editIndiceDetailActivity: '',
        listDetailsActivities: [],
        recursos: {
            id_minuta: '',
            nombre: '',
            url: '',
        },
        recursosList: [],
        recursosLastList: [],
        recursosDialog: false,
        listaResponsablesActividades: [],
        lastEventPermissions: false,
        disableNombreActivities: false,
        disableFechaInicioActivities: false,
        disableEditActivities: false,
        dialogReprogramar: false,
        fechaReprogramacion: {
            fecha: '',
            hora_inicio: '',
            hora_fin: ''
        },
        loadingReprogramar: false,
        endMenuReprogramacion: false,
        startMenuReprogramacion: false,

        dialogNuevasReuniones: false,
        loadingNuevasReuniones: false,
        endMenuNuevaReunion: false,
        startMenuNuevaReunion: false,
        btnSumarReuniones: false,
        disableDate: [],
        fechaNuevaReunion: {
            fecha: [],
            hora_inicio: '',
            hora_fin: ''
        },
        dialogCoCreador: false,
        disableCoCreadorList: false,
        loadingCoCreador: false,
        loadingFetchDialog: false,
        listaConvocadosCoCoordinador: [],
        retirarConvocadosDialog: false,
        listaConvocadosEliminar: [],
        loadingRetirarConvocados: false,
        dialogConfirmReabrir: false,
        cargandoReapertura: false,

        //encuestas
        dialogEvaluar: false,
        selectedSurvey: null,

        //Nivel 6
        userSelected: null,
        userViewing: null,
        campanaFiltro: null,
        listaUsuarios: [
            {
                id: 13494,
                nombre_completo: "ANGELA VALERIA DEL CASTILLO VILLACORTA"
            }
        ],
        dialogVerEncuesta: false,
        cargandoEncuestas: false,
        listaEncuestas: [],



    }),
    watch: {
        notify: {
            handler(newVal) {
                if (newVal.length > 0) {
                    const latestNotification = newVal[0];
                    if (latestNotification.eventDetails) {
                        this.predefinedEvents.push({
                            name: latestNotification.eventDetails.name,
                            start: new Date(latestNotification.eventDetails.start),
                            end: new Date(latestNotification.eventDetails.end),
                            color: latestNotification.eventDetails.color,
                            timed: latestNotification.eventDetails.timed,
                            details: latestNotification.eventDetails.details
                        });
                        // Forzar actualización del calendario
                        const currentType = this.type;
                        //this.type = 'week'; // Cambiar a un valor temporal
                        this.$nextTick(() => {
                            this.$refs.calendar.checkChange();
                            //this.type = currentType; // Volver a 'month'
                        });
                    }
                }
            },
            deep: true
        },
        selectedEvent(newEvent) {
            console.log('selectedEvent:', newEvent);
        },
        dialogMinuta(val) {
            // Si el diálogo se abre Y es una minuta nueva (minuta.id === null)
            if (val && this.minuta.id === null) {
                this.minuta.nombreReunion = this.selectedEvent.name;
            }
        }
    },

    mounted() {
        this.$refs.calendar.checkChange()
        this.loadEvents();
        this.fetchInternos();
        this.fetchClients();
        this.cargandoMinutas = true;
        // this.$axios.get('getMinutasAnteriores')
        //     .then(response => {
        //         this.minutasAnteriores = response.data;
        //         this.cargandoMinutas = false;
        //     }).catch(error => {
        //         console.error('Error al obtener las minutas anteriores:', error);
        //         this.cargandoMinutas = false;
        //     });
    },
    computed: {
        ...mapGetters(['getCampanas', 'getCampanasAsignadas']),
        filteredCampanas() {
            var lista = this.getCampanas.filter(campana =>
                this.getCampanasAsignadas.includes(campana.Id.toString())
            );

            return lista.sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        formattedConvocados() {
            return this.filteredConvocados().map(convocado => {
                return {
                    ...convocado,
                    fullName: `${convocado.vc_Nombres} ${convocado.vc_ApePaterno} ${convocado.vc_ApeMaterno} (${convocado.tipo})`
                };
            }).filter(item => item.id != this.$store.state.id);
        },
        organizer() {
            return this.selectedEvent.invitees && this.selectedEvent.invitees.length > 0
                ? this.selectedEvent.invitees.find(invitee => invitee.role === 'Organizador')
                : null;
        },
        creatorId() {
            return this.$store.state.id;
        },
        Rol() {
            return this.$store.state.rol;
        },
        Nivel() {
            return this.$store.state.nivel;
        },
        filteredRecurrenceOptions() {
            if (this.form.dateMeet.length > 1) {
                return this.recurrenceOptions.filter(option => option.value === 'No recurrente');
            }
            return this.recurrenceOptions;
        },
        isCreator() {
            const userId = Number(this.$store.state.id);
            const creatorId = Number(this.selectedEvent.creador_evento);
            return userId == creatorId;
        },
        isCoCreator() {
            const userId = Number(this.$store.state.id);
            const creatorId = Number(this.selectedEvent.cocreador);
            return userId == creatorId;
        },
        isRespAct() {
            const userId = Number(this.$store.state.id);
            const respIds = this.selectedEvent.responsable_act
                ? this.selectedEvent.responsable_act.split(',').map(Number)
                : [];
            return respIds.includes(userId);
        },
        canEdit() {
            return (index) => {
                // El primer elemento siempre puede ser editado 
                if (index === 0) return true;
                // Los elementos posteriores pueden ser editados solo si el anterior tiene valor 
                return this.minuta.convocados[index - 1].asistencia !== '';
            };
        },
        remainingFiles() {
            // Calcula el número de archivos que aún se pueden cargar
            const archivosNuevos = this.minuta.archivosCargados.filter(archivo => archivo.antiguedad === 'nuevo').length;
            return Math.max(this.maxFiles - archivosNuevos, 0);

            //return Math.max(this.maxFiles - this.minuta.archivosCargados.length, 0)
        },
        filteredConvocadosHistorial() {
            if (!this.minuta.id || !this.minuta.convocadosHistorial) {
                return [];
            }
            // return this.minuta.convocadosHistorial.filter(convocado => convocado.minuta_id < this.minuta.id);
        },
        sortedConvocados() {
            return [...this.formattedConvocados].sort((a, b) => a.fullName.localeCompare(b.fullName));
        },
        allActivitiesClosed() {
            if (this.minuta.actividades.length === 0) return false; // No finalizar si está vacía
            return this.minuta.actividades.every(act => act.status === 'Cerrado');
        },
        nombreUsuarioActivo() {
            if (!this.userSelected) return '';
            const usuario = this.listaUsuariosPorCampana.find(u => u.id === this.userSelected);
            return usuario ? usuario.nombre_completo : '';
        },
        listaUsuariosPorCampana() {
            if (!this.campanaFiltro) return [];

            const miId = this.$store.state.id;
            // Filtramos los internos que pertenecen a la campaña seleccionada
            return this.internos
                .filter(interno =>
                    interno.campanas.some(c => c.in_CampanaId == this.campanaFiltro) &&
                    interno.id != miId
                )
                .map(interno => ({
                    id: interno.id,
                    nombre_completo: `${interno.vc_Nombres} ${interno.vc_ApePaterno} ${interno.vc_ApeMaterno}`.toUpperCase()
                }))
                .sort((a, b) => a.nombre_completo.localeCompare(b.nombre_completo));
        }
    },
    methods: {
        validateAsistencia(status) {
            if (status == 'yes') {
                return 'Si';
            } else if (status == 'no') {
                return 'No';
            } else if (status == 'r') {
                return 'R';
            } else {
                return '';
            }

        },
        existCoCreador() {
            try {
                if (this.selectedEvent.cocreador != null && this.selectedEvent.cocreador.length > 0) {
                    return true;
                }
            } catch (error) {
                return false;
            }

            return false;
        },
        getListaCocredor() {
            try {
                var convocadosDisponibles = [];
                convocadosDisponibles.push({ id: null, name: 'No Asignar' });
                this.selectedEvent.invitees.map(item => {
                    if (item.role != "Organizador" && item.type_invitee == "interno") {
                        convocadosDisponibles.push(item);
                    }
                });

                return convocadosDisponibles;
            } catch (error) {
                return [];
            }
        },
        getNameCoCreador(id) {
            try {
                return this.selectedEvent.invitees.map(item => {
                    if (item.id == id) {
                        return item.name
                    }
                });
            } catch (error) {
                return null;
            }
        },
        async asignarCoCreador() {
            this.loadingCoCreador = true;

            const payload = {
                event_id: this.selectedEvent.id,
                event_codigo: this.selectedEvent.codigo,
                id_coCreador: this.coCreadoSelected
            }

            var keyCurrenEvent = this.events.map((item, index) => {
                if (item.codigo == this.selectedEvent.codigo) {
                    return index;
                }
                return -1;
            }).filter(index => index !== -1);

            const response = await this.$axios.post('/minuta/add/cocreador', payload);
            if (response.data.status) {
                var resCoCreador = this.coCreadoSelected == null ? "" : this.coCreadoSelected;

                this.events.map((item, index) => {
                    if (keyCurrenEvent.includes(index)) {
                        this.events[index].cocreador = resCoCreador
                    }
                })

                this.$toast.success(response.data.msg, {
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
                this.coCreadoSelected = null;
                this.loadingCoCreador = false;
                this.dialogCoCreador = false;
                // setTimeout(() => {
                //     this.loadEvents();
                // }, 2000);
            } else {
                this.$toast.error(response.data.msg, {
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
            }
            this.coCreadoSelected = null;
            this.disableCoCreadorList = false;
            this.loadingCoCreador = false;

        },
        cerrarDialogCoCreador() {
            this.coCreadoSelected = null;
            this.dialogCoCreador = false;
            this.loadingCoCreador = false;

        },
        async openDialogcoCreador(codigo) {
            this.loadingFetchDialog = true;
            const response = await this.$axios.post('/minuta/getconvocados/' + codigo);
            var data = response.data.invitados.map(item => {
                return {
                    id: item.dni_invitado,
                    name: this.nameByLeader(item.dni_invitado)
                }
            });


            if (response.data.coordinador != null) {
                this.disableCoCreadorList = true;
            } else {
                this.disableCoCreadorList = false;
            }
            this.cocreadorId = response.data.coordinador;
            this.listaConvocadosCoCoordinador = [{ id: null, name: 'No asignar' }, ...data];
            this.dialogCoCreador = true;
            this.loadingFetchDialog = false;
        },
        nameByLeader(id) {
            var user = this.internos.filter(interno => interno.id == id);
            return user[0].vc_Nombres + ' ' + user[0].vc_ApePaterno + ' ' + user[0].vc_ApeMaterno;
        },
        openNuevasReuniones() {
            this.disableDate = [];
            this.fechaNuevaReunion.fecha = [];
            this.fechaNuevaReunion.hora_inicio = '';
            this.fechaNuevaReunion.hora_fin = '';
            let group = this.events.filter(item => item.codigo == this.selectedEvent.codigo && item.minutas[0].id_minuta !== undefined);
            group.map(item => {
                const date = new Date(item.start);
                const formattedDate = date.toISOString().split('T')[0];
                this.disableDate.push(formattedDate);
            });
            this.dialogNuevasReuniones = true;
            this.loadingNuevasReuniones = false;
            this.fechaNuevaReunion.fecha = this.disableDate;

        },
        cancelarNuevaReunion() {
            this.dialogNuevasReuniones = false;
            this.loadingNuevasReuniones = false;
        },
        disableNuevaReunion() {
            if (this.fechaNuevaReunion.fecha.length > 0) {
                return false;
            }

            if (this.fechaNuevaReunion.hora_inicio.length > 0) {
                return false;
            }

            if (this.fechaNuevaReunion.hora_fin.length > 0) {
                return false;
            }

            return true;
        },
        validacionNuevasReuniones() {
            const today = new Date();
            const todayFormatted = today.toISOString().split('T')[0];

            const filteredDates = this.disableDate.filter(date => date >= todayFormatted);
        },
        async nuevasReuniones() {
            this.loadingNuevasReuniones = true;

            this.validacionNuevasReuniones();

            const payload = {
                evento_id: this.selectedEvent.id,
                codigo: this.selectedEvent.codigo,
                fecha: this.fechaNuevaReunion.fecha,
                hora_inicio: this.fechaNuevaReunion.hora_inicio,
                hora_fin: this.fechaNuevaReunion.hora_fin
            };


            try {
                const response = await this.$axios.post('/event/nuevas/reuniones', payload);
                if (response.data.status) {
                    this.$toast.success(response.data.msg, {
                        position: "bottom-left",
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });

                    this.loadingNuevasReuniones = false;
                    this.dialogNuevasReuniones = false;
                    this.loadEvents();
                    this.resetForm();
                }

                if (!response.data.status) {
                    this.$toast.info(response.data.msg, {
                        position: "bottom-left",
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });
                    this.loadingNuevasReuniones = false;
                }

            } catch (error) {
                this.loadingNuevasReuniones = false;

            }


        },
        openReprogramar() {
            this.dialogReprogramar = true;
            // this.fechaReprogramacion = '';

            this.loadingReprogramar = false;
        },
        async reprogramar() {
            this.loadingReprogramar = true;
            const payload = {
                evento_id: this.selectedEvent.id,
                codigo: this.selectedEvent.codigo,
                fecha: this.fechaReprogramacion.fecha,
                hora_inicio: this.fechaReprogramacion.hora_inicio,
                hora_fin: this.fechaReprogramacion.hora_fin
            };

            try {
                const response = await this.$axios.post('/event/reprogramar', payload);
                if (response.data.status) {
                    this.$toast.success(response.data.msg, {
                        position: "bottom-left",
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });
                    this.loadingReprogramar = false;
                    this.dialogReprogramar = false;
                    this.loadEvents();
                    this.cancel();
                    this.resetForm();
                }

                if (!response.data.status) {
                    this.$toast.info(response.data.msg, {
                        position: "bottom-left",
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });
                    this.loadingReprogramar = false;
                }

            } catch (error) {
            }


        },
        cancelarReprogramacion() {
            this.dialogReprogramar = false;
            // this.fechaReprogramacion = '';
        },
        disableReprogramacion() {
            if (this.fechaReprogramacion.fecha.length > 0) {
                return false;
            }

            if (this.fechaReprogramacion.hora_inicio.length > 0) {
                return false;
            }

            if (this.fechaReprogramacion.hora_fin.length > 0) {
                return false;
            }
        },
        permisosMostrarActivities(actividad = null, options) {
            // valida si la minuta es la ultima creada para poder editar
            if (!this.lastEventPermissions) {
                return false;
            }

            // valida si es el creador
            if (this.isCreator || this.isCoCreator) {
                return true;
            }

            if (options == 'trash') {
                return false;
            }

            // valida si es el reponsable del punto asignado
            /*if (this.$store.state.id == actividad.responsable) {
                return true;
            }*/
            const responsables = actividad.responsable; // o actividad.responsable, según tu objeto

            if (Array.isArray(responsables)) {
                // Buscamos si el ID del usuario actual está en esa lista
                return responsables.includes(this.$store.state.id.toString());
            }

            return false;
        },
        permisosDisableActividad(accion) {
            if (this.isCreator) {
                this.disableEditActivities = false;
                this.disableNombreActivities = false;
                this.disableFechaInicioActivities = false;;
            }

            if (this.$store.state.rol == 39 && accion == 'create') {
                this.disableEditActivities = true;
                this.disableNombreActivities = false;
                this.disableFechaInicioActivities = false;
            }

            if (this.$store.state.rol == 39 && accion == 'edit') {
                this.disableEditActivities = true;
                this.disableNombreActivities = true;
                this.disableFechaInicioActivities = true;
            }

        },
        openExternalPage(link) {
            window.open(link, '_blank');
        },
        agregarRecursos() {
            this.recursosList.push({ ...this.recursos });
            this.recursos.id_minuta = '';
            this.recursos.nombre = '';
            this.recursos.url = '';
        },
        removeRecursos(index) {
            this.recursosList.splice(index, 1);
        },
        cerrarRecursos() {
            this.recursosDialog = false;
        },
        listarConvocados(eventoId) {
            let currentEvent = this.events.find(event => event.id == eventoId);

            if (!currentEvent || !eventoId) {
                return '';
            }

            let clientesFiltrados = this.clientes.filter(cliente =>
                cliente.campanas.some(campana => currentEvent.campana.includes(campana.in_CampanaId))
            ).map(cliente => ({
                ...cliente,
                tipo: 'cliente'
            }));

            let internosFiltrados = this.internos.filter(interno =>
                interno.campanas.some(campana => currentEvent.campana.includes(campana.in_CampanaId))
            ).map(interno => ({
                ...interno,
                tipo: 'interno'
            }));


            var listaConvocados = [...internosFiltrados, ...clientesFiltrados];


            let currentEventInv = [];
            currentEvent.invitees.forEach(element => {
                currentEventInv.push(parseInt(element.id))
            });


            listaConvocados = listaConvocados.map(item => {
                if (!currentEventInv.includes(item.id)) {
                    return item
                }
            }).filter(item => item !== undefined);


            var lista = listaConvocados.map(convocado => {
                return {
                    fullName: `${convocado.vc_Nombres} ${convocado.vc_ApePaterno} ${convocado.vc_ApeMaterno}(${convocado.tipo})`,
                    id: convocado.id,
                    rol: convocado.in_PerfilId == 39 ? 'Invitado' : 'Organizador',
                    tipo_invitado: convocado.tipo
                }
            });

            return lista.sort((a, b) => a.fullName.localeCompare(b.fullName));

        },
        ordenAlfabetico(lista) {
            return lista.sort((a, b) => a.fullName.localeCompare(b.fullName));
        },
        listarParticipantesSinOrganizadores(eventoId) {
            let currentEvent = this.events.find(event => event.id == eventoId);

            if (!currentEvent || !eventoId) {
                return '';
            }

            let clientesFiltrados = this.clientes.filter(cliente =>
                cliente.campanas.some(campana => currentEvent.campana.includes(campana.in_CampanaId))
            ).map(cliente => ({
                ...cliente,
                tipo: 'cliente'
            }));

            let internosFiltrados = this.internos.filter(interno =>
                interno.campanas.some(campana => currentEvent.campana.includes(campana.in_CampanaId))
            ).map(interno => ({
                ...interno,
                tipo: 'interno'
            }));


            var listaConvocados = [...internosFiltrados, ...clientesFiltrados];


            let currentEventInv = [];
            currentEvent.invitees.forEach(element => {
                if (element.id != this.selectedEvent.creador_evento && element.id != this.selectedEvent.cocreador) {
                    currentEventInv.push(parseInt(element.id))
                }
            });


            listaConvocados = listaConvocados.map(item => {
                if (currentEventInv.includes(item.id)) {
                    return item
                }
            }).filter(item => item !== undefined);


            var lista = listaConvocados.map(convocado => {
                return {
                    fullName: `${convocado.vc_Nombres} ${convocado.vc_ApePaterno} ${convocado.vc_ApeMaterno}(${convocado.tipo})`,
                    id: convocado.id,
                    rol: convocado.in_PerfilId == 39 ? 'Invitado' : 'Organizador',
                    tipo_invitado: convocado.tipo
                }
            });

            return lista.sort((a, b) => a.fullName.localeCompare(b.fullName));
        },
        async retirarConvocados() {
            this.loadingRetirarConvocados = true;

            if (this.listaConvocadosEliminar.length == 0) {
                this.$toast.error('Es necesario seleccionar un convocado');
                return false;
            }

            const payload = {
                evento_id: this.selectedEvent.id,
                convocados: this.listaConvocadosEliminar,
                codigo: this.selectedEvent.codigo
            }

            try {
                const response = await this.$axios.post('/minuta/convocados/eliminar', payload);

                if (response.data.status) {
                    this.$toast.success(response.data.msg);

                    console.log(this.selectedEvent.invitees);
                    this.listaConvocadosEliminar.map(item => {

                        this.selectedEvent.invitees = this.selectedEvent.invitees.filter(elem => elem.id != item.id);

                    })

                    this.cargarConvocados(this.selectedEvent.id);
                    this.loadEvents();

                }

            } catch (error) {

                this.listaConvocadosEliminar = [];
                this.loadingRetirarConvocados = false;
            }


            this.listaConvocadosEliminar = [];
            this.loadingRetirarConvocados = false;
            this.retirarConvocadosDialog = false;

        },
        limpiarAgregarConvocadosDialog() {
            this.listaConvocadosPendientes = [];
            this.loadingAgregarConvocadosDialog = false;
            this.AgregarConvocadosDialog = false;
        },
        cancelarAgregarConvocadosDialog() {
            this.limpiarAgregarConvocadosDialog();
        },
        async agregarAgregarConvocadosDialog(eventoId) {
            this.loadingAgregarConvocadosDialog = true;
            let currentEvent = this.events.find(event => event.id == eventoId);

            if (this.listaConvocadosPendientes.length == 0) {
                this.$toast.error('Es necesario seleccionar un convocado', {
                    position: "bottom-left",
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
                this.limpiarAgregarConvocadosDialog();

                return false;
            }

            const payload = {
                evento_id: eventoId,
                convocados: this.listaConvocadosPendientes,
                codigo: currentEvent.codigo
            }

            try {
                const response = await this.$axios.post('/minuta/convocados/agregar', payload);

                if (response.data.status) {

                    this.$toast.success(response.data.msg, {
                        position: "bottom-left",
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });

                    this.listaConvocadosPendientes.map(item => {
                        let data = {
                            id: item.id,
                            name: item.fullName.split('(')[0],
                            role: item.rol,
                            type_invitee: item.tipo_invitado
                        };

                        this.selectedEvent.invitees.push(data);

                        if (item.tipo_invitado == 'interno') {
                            this.filteredLeaders.push(data);
                        } else {
                            this.filteredClients.push(data);
                        }
                    });



                    this.cargarConvocados(eventoId);
                    this.limpiarAgregarConvocadosDialog();
                    this.loadEvents();

                }
                else {
                    this.$toast.error(response.data.msg, {
                        position: "bottom-left",
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });
                }

            } catch (error) {
            }

            this.loadingAgregarConvocadosDialog = false;
        },
        obtenerFechaActual() {
            const fecha = new Date();
            const anio = fecha.getFullYear();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript son de 0 a 11
            const dia = String(fecha.getDate()).padStart(2, '0'); // Asegurarse de que el día tenga dos dígitos
            return `${anio}-${mes}-${dia}`;
        },
        addDetailsActivities() {

            if (this.newDetailActivity.length > 250) {
                return false;
            }
            if (this.newDetailActivity.trim()) {

                let cadena = this.newDateDetailActivity.length > 0 ? this.newDateDetailActivity : '';

                if (this.editDetailActivityStatus == true) {
                    this.listDetailsActivities[this.editIndiceDetailActivity].texto = this.newDetailActivity;
                    this.listDetailsActivities[this.editIndiceDetailActivity].fecha_compromiso = cadena;
                    //  = {
                    //     texto: this.newDetailActivity,
                    //     fecha_compromiso : cadena
                    // };cadena + ' - ' + this.newDetailActivity
                } else {
                    this.listDetailsActivities.push({
                        texto: this.newDetailActivity,
                        fecha_compromiso: cadena,
                        fecha_inicio: this.obtenerFechaActual()
                    });
                }

                this.newDetailActivity = '';
                this.editIndiceDetailActivity = '';
                this.newDateDetailActivity = '';
                this.$toast.success('Detalle añadido a la lista');
                this.editDetailActivityStatus = false;
            }
        },
        editDetailActivity(index) {
            this.editDetailActivityStatus = true;
            this.editIndiceDetailActivity = index;
            let activity = this.listDetailsActivities[index]
            this.newDetailActivity = activity.texto;
            this.newDateDetailActivity = activity.fecha_compromiso == 'Sin fecha de compromiso de cierre' ? '' : activity.fecha_compromiso;

        },
        removeDetailActivity(index) {
            this.listDetailsActivities.splice(index, 1);
        },
        serializeDetailActivity(list) {
            return list
        },
        addBullet() {
            if (this.newBullet) {
                this.newData.bullets.push(this.newBullet);
                this.newBullet = '';
            }
        },
        removeBullet(index) {
            this.newData.bullets.splice(index, 1);
        },
        addData() {
            if (this.$refs.form.validate() && this.selectedItem) {
                // Agregar el nuevo dato como un nuevo objeto en el array data del item seleccionado
                let item = this.items.find(i => i.id === this.selectedItem.id);
                if (!item) {
                    item = { id: this.selectedItem.id, name: this.selectedItem.text, data: [] };
                    this.items.push(item);
                }
                item.data.push({ ...this.newData });
                this.newData.text = '';
                this.newData.bullets = [];
                this.$refs.form.reset();
            }
        },
        sendData() {
            this.$axios.post('detailsActivities', { items: this.items })
                .then(response => {
                    this.resetActivity();
                })
                .catch(error => {
                    console.error('Error al enviar los datos:', error);
                });
        },
        resetActivity() {
            this.newData = {
                text: '',
                bullets: []
            };
            this.newBullet = '';
            this.selectedItem = null;
            this.items = [];
            this.$refs.form.reset();
            this.dialogActResponsable = false;
        },
        getActivities() {
            this.loadingActivities = true;
            this.$axios.post('getActivities', {
                user_id: this.$store.state.id,
                minuta_id: this.selectedEvent.id_minuta
            })
                .then(response => {
                    this.activities = response.data.activities.map(activity => ({
                        id: activity.id,
                        text: activity.actividad
                        // Asegúrate de que 'activity_name' es el campo correcto 
                    }));

                    // Formatear los detalles de actividades 
                    const groupedDetails = response.data.activityDetails.reduce((acc, detail) => {
                        const activityId = detail.actividad_id;
                        if (!acc[activityId]) {
                            acc[activityId] = {
                                id: activityId,
                                name: '', // Nombre de la actividad, actualizaremos más adelante 
                                data: []
                            };
                        }

                        const bullets = detail.vinetas ? detail.vinetas.split(', ') : [];
                        acc[activityId].data.push({
                            text: detail.detalles,
                            bullets: bullets
                        });
                        return acc;
                    }, {});

                    this.items = Object.keys(groupedDetails).map(activityId => {
                        const activity = this.activities.find(act => act.id == activityId);
                        if (activity) {
                            groupedDetails[activityId].name = activity.text;
                        }
                        return groupedDetails[activityId];
                    });
                    this.loadingActivities = false;
                    this.dialogActResponsable = true;
                })
                .catch(error => {
                    console.log('Hubo un error al obtener los datos');
                });
        },
        showActivityDetails(item, minuta_id, responsable_id) {
            this.selectedActivity = item;
            this.$axios.post('getActivities', {
                user_id: responsable_id,
                minuta_id: item.minuta_id
            })
                .then(response => {
                    //const activityDetails = response.data.activityDetails;
                    const activities = response.data.activities;

                    const groupedDetails = response.data.activityDetails.reduce((acc, detail) => {
                        const activityId = detail.actividad_id;
                        if (!acc[activityId]) {
                            acc[activityId] = {
                                id: activityId,
                                name: '', // Nombre de la actividad, actualizaremos más adelante 
                                data: []
                            };
                        }

                        const bullets = detail.vinetas ? detail.vinetas.split(', ') : [];
                        acc[activityId].data.push({
                            text: `${detail.fecha}: ${detail.detalles}`,
                            bullets: bullets
                        });
                        return acc;
                    }, {});

                    this.processedDetails = Object.keys(groupedDetails).map(activityId => {
                        const activity = activities.find(act => act.id == activityId);
                        if (activity) {
                            groupedDetails[activityId].name = activity.actividad;
                        }
                        return groupedDetails[activityId];
                    });
                    this.activityDialog = true;
                }).catch(error => {
                    console.error('Error al obtener los detalles de la actividad:', error);
                });
        },
        limpiarActividad() {
            this.editDetailActivityStatus = false;
            this.newActivity.actividad = '';
            this.newActivity.responsable = [];
            this.newActivity.detalles = '';
            this.newActivity.status = '';
            this.newActivity.fechaInicio = '';
            this.listDetailsActivities = []
            this.newDetailActivity = '';
            this.editIndiceDetailActivity = '';
        },
        editActivities(index, item) {
            this.editActivity = true;
            this.limpiarActividad();
            this.idActivity = index;
            let actividadTmp = this.minuta.actividades[index];
            this.newActivity.actividad = actividadTmp.actividad;
            //this.newActivity.responsable = actividadTmp.responsable;
            if (typeof actividadTmp.responsable === 'string') {
                this.newActivity.responsable = actividadTmp.responsable.split(',');
            } else {
                this.newActivity.responsable = actividadTmp.responsable || [];
            }
            this.listDetailsActivities = actividadTmp.detalles;
            this.newActivity.detalles = actividadTmp.detalles;
            this.newActivity.status = actividadTmp.status;
            this.newActivity.fechaInicio = actividadTmp.fechaInicio;
            this.dialogActivity = true;
            this.permisosDisableActividad('edit')

            const date = new Date('Wed Feb 12 2025 00:30:00 GMT-0500 (Peru Standard Time)');
            const formattedDate = date.getFullYear().toString() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
            this.dateMinActividades = formattedDate;
        },
        closeActivities() {
            this.editActivity = false;
            this.dialogActivity = false;
            this.disableEditActivities = false;
            this.disableNombreActivities = false;
            this.disableFechaInicioActivities = false;
        },
        openActivities() {
            this.dialogActivity = true;
            this.limpiarActividad();
            this.permisosDisableActividad('create');
        },
        updateStatus(item) {
            // Encuentra el índice de la actividad en minuta.actividades
            const activityIndex = this.minuta.actividades.findIndex(activity => activity.id === item.id);
            if (activityIndex !== -1) {
                // Actualiza el estado de la actividad
                this.$set(this.minuta.actividades, activityIndex, {
                    ...this.minuta.actividades[activityIndex],
                    status: item.status
                });
            }
        },
        openformActivities() {
            this.getActivities();
        },
        async fetchInternos() {
            try {
                const response = await this.$axios.get('getInternos');
                this.internos = response.data.all;
            } catch (error) {
                console.error('Error al obtener los internos:', error);
            }
        },
        async fetchClients() {
            try {
                const response = await this.$axios.get('getClients');
                this.clientes = response.data.all;
            } catch (error) {
                console.error('Error al obtener los clientes:', error);
            }
        },
        filteredConvocados() {
            if (!this.form.campana || !this.selectedMeetingType) {
                return []; // No se ha seleccionado ninguna campaña o tipo de reunión
            }
            return this.getFilteredConvocados(this.form.campana, this.selectedMeetingType);
        },
        getFilteredConvocados(campanaId, meetingType) {

            if (!campanaId) {
                return [];
            }
            const campanaIdNum = Number(campanaId);

            // Filtrar internos por campaña seleccionada
            let internosFiltrados = this.internos.filter(interno =>
                interno.campanas.some(campana => campanaId.includes(campana.in_CampanaId))
            ).map(interno => ({
                ...interno,
                tipo: 'interno'
            }));

            // Filtrar clientes por campaña seleccionada
            let clientesFiltrados = this.clientes.filter(cliente =>
                cliente.campanas.some(campana => campanaId.includes(campana.in_CampanaId))
            ).map(cliente => ({
                ...cliente,
                tipo: 'cliente'
            }));

            if (meetingType === 'interno') {
                // Si el tipo de reunión es 'interno', devolver solo los internos filtrados por campaña
                return internosFiltrados;
            } else if (meetingType === 'cliente') {
                // Si el tipo de reunión es 'cliente', devolver internos y clientes filtrados por campaña
                return [...internosFiltrados, ...clientesFiltrados];
            }

            // Si el tipo de reunión no es 'interno' ni 'cliente', devolver internos y clientes filtrados por campaña
            return [...internosFiltrados, ...clientesFiltrados];
        },
        getFormattedConvocados(campanaId, meetingType) {
            return this.getFilteredConvocados(campanaId, meetingType).map(convocado => {
                return {
                    ...convocado,
                    fullName: `${convocado.vc_Nombres} ${convocado.vc_ApePaterno} ${convocado.vc_ApeMaterno}(${convocado.tipo})`
                };
            });
        },
        getRepresentativeFullName(representanteId) {
            const representante = this.findRepresentativeById(representanteId);
            return representante ? `${representante.vc_Nombres} ${representante.vc_ApePaterno} ${representante.vc_ApeMaterno}` : '';
        },
        findRepresentativeById(id) {
            const interno = this.internos.find(interno => interno.id == id);
            if (interno) {
                return interno;
            }
            const cliente = this.clientes.find(cliente => cliente.id == id);
            return cliente || null;
        },
        listLideres(campanaId) {
            const campanaIdNum = Number(campanaId);
            // Filtrar internos por campaña seleccionada
            let internosFiltrados = this.internos.filter(interno =>
                interno.campanas.some(campana => campana.in_CampanaId === campanaIdNum)
            ).map(interno => ({
                ...interno,
                tipo: 'interno'
            }));
            return internosFiltrados;
        },
        getStatusClass(status) {
            const statusOption = this.statusOptions.find(option => option.value === status);
            if (!statusOption) return '';

            // Si es Seguimiento, usamos texto negro. Si no, texto blanco.
            const textColor = (status === 'Seguimiento') ? 'black--text' : 'white--text';

            // Retornamos el color de fondo + el color de texto
            // Ejemplo: "yellow black--text" o "green white--text"
            return `${statusOption.color} ${textColor}`;
        },
        uppercaseName(name) {
            return name.toUpperCase();
        },
        //ejemplo minuta
        addAgendaItem() {
            // Lógica para agregar un nuevo ítem a la agenda
            if (this.newAgendaItem.trim() !== '') {
                this.minuta.agenda.push({ item: this.newAgendaItem });
                this.newAgendaItem = '';
            }
        },
        removeAgendaItem(index) {
            this.minuta.agenda.splice(index, 1);
        },
        validateFormActividades() {
            if (this.newActivity.actividad.length == '') {
                return false;
            }

            if (this.newActivity.responsable.length == '') {
                return false;
            }

            if (this.newActivity.fechaInicio.length == '') {
                return false;
            }

            if (this.newActivity.status.length == '') {
                return false;
            }

            if (this.newActivity.status.length == '') {
                return false;
            }

            if (this.listDetailsActivities.length == 0) {
                return false;
            }

            return true;

        },
        addActivity(continuar = false) {
            //console.log('Hola estoy aqui');

            if (!this.validateFormActividades()) {
                this.$toast.info('llena todos los campos', {
                    position: "bottom-left",
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
                return '';
            }

            if (this.editActivity) {
                //console.log('entramos aqui');
                this.newActivity.detalles = [...this.listDetailsActivities];

                this.minuta.actividades[this.idActivity].actividad = this.newActivity.actividad;
                this.minuta.actividades[this.idActivity].responsable = this.newActivity.responsable;
                this.minuta.actividades[this.idActivity].detalles = this.newActivity.detalles;
                this.minuta.actividades[this.idActivity].fechaInicio = this.newActivity.fechaInicio;
                this.minuta.actividades[this.idActivity].status = this.newActivity.status;
                //this.permisosDisableActividad('edit');
                if (this.minuta.id !== null) {
                    //console.log('entre aqui');
                    this.actualizarActividad(this.newActivity, this.minuta.actividades[this.idActivity].id);
                }

            } else {
                if (this.newActivity.actividad.trim() !== '') {
                    this.permisosDisableActividad('create');
                    var activities = [];

                    this.listDetailsActivities.forEach(element => {
                        activities.push(element);
                    });

                    this.newActivity.detalles = activities;

                    this.minuta.actividades.push({ ...this.newActivity });

                    if (this.minuta.id !== null) {
                        this.agregarActividad(this.newActivity, null);
                    }

                    this.newActivity = {
                        actividad: '',
                        responsable: [],
                        detalles: '',
                        fechaInicio: '',
                        status: ''
                    };

                    this.listDetailsActivities = [];
                }
            }

            if (!continuar) {
                this.editActivity = false;
                this.dialogActivity = false;
                this.disableEditActivities = false;
                this.disableNombreActivities = false;
                this.disableFechaInicioActivities = false;
            } else {
                this.$toast.success('Actividad guardada, puedes agregar otra');
            }

        },
        async agregarActividad(actividad, id = null) {
            const data = {
                actividad: JSON.stringify(actividad),
                minuta_id: this.minuta.id,
                actividad_id: id
            }

            try {
                const response = await this.$axios.post('/actividades/agregar', data);
                this.listarActividades(this.minuta.id);
            } catch (error) {

            }
        },
        async actualizarActividad(actividad, id) {
            const data = {
                actividad: JSON.stringify(actividad),
                minuta_id: this.minuta.id,
                actividad_id: id
            }
            try {
                const response = await this.$axios.post('/actividades/actualizar', data)
                this.listarActividades(this.minuta.id)

            } catch (error) {
                console.log('Hubo un error en los datos');
            }
        },
        async listarActividades(minuta_id) {
            const response = await this.$axios.get('actividades/' + minuta_id);

            const actividades = response.data;

            this.minuta.actividades = [];
            let valores = Object.values(actividades);
            for (let i = 0; i < valores.length; i++) {

                var actividadesDetalle = valores[i]['detalles'].map(item => {

                    var fecha = item[0].split(' - ')[0];
                    var texto = item[0].split(' - ')[1];
                    return { fecha_compromiso: fecha, texto: texto, fecha_inicio: item[1] };
                });

                this.minuta.actividades.push({
                    id: valores[i]['actividad_id'],
                    actividad: valores[i]['actividad'],
                    //responsable: valores[i]['dni_responsable'],
                    responsable: valores[i]['dni_responsable']
                        ? valores[i]['dni_responsable'].split(',')
                        : [],
                    detalles: actividadesDetalle,
                    fechaInicio: valores[i]['fecha_inicio'],
                    status: valores[i]['status'],
                });
            }

        },
        removeActivity(index) {
            this.minuta.actividades.splice(index, 1);
        },
        async submitForm() {

            var validateFormFile = this.minuta.archivos.map(element => {
                return element.size >= this.maxSize ? true : false;
            });


            if (validateFormFile.includes(true)) {
                this.$toast.error('Los archivos superan el tamaño permitido', {
                    position: "bottom-left",
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
                this.loadingAddMnt = false;
                return false;
            }

            this.loadingAddMnt = true;
            // Lógica para enviar el formulario
            const formData = new FormData();

            //Datos de la minuta
            const minutaData = [
                this.selectedEvent.id,
                this.minuta.nombreReunion,
                this.minuta.fechaReunion,
                this.minuta.objetivoReunion,
                this.minuta.lugar,
                this.$store.state.id
            ].join('†');

            // Convocados
            const convocadosData = this.minuta.convocados.map(convocado =>
                `${convocado.name}†${convocado.asistencia}†${convocado.representante}`
            ).join('‡');

            // Agenda
            const agendaData = this.minuta.agenda.map(item =>
                `${item.item}`
            ).join('‡');

            // Actividades
            /*const actividadesData = this.minuta.actividades.map(actividad =>
                `${actividad.actividad}†${actividad.responsable}†${actividad.detalles}†${actividad.fechaInicio}†${actividad.status}`
            ).join('‡');*/
            const actividadesData = this.minuta.actividades.map(actividad => {
                // Si responsable es array [1,2], lo unimos con comas "1,2". Si no, se queda igual.
                const resp = Array.isArray(actividad.responsable)
                    ? actividad.responsable.join(',')
                    : actividad.responsable;

                return `${actividad.actividad}†${resp}†${actividad.detalles}†${actividad.fechaInicio}†${actividad.status}`;
            }).join('‡');


            // Añadir datos al FormData
            formData.append('data', [
                minutaData,
                convocadosData,
                agendaData,
                actividadesData
            ].join('¥'));

            // Añadir archivos seleccionados anteriores al FormData 
            if (this.minuta.archivosCargadosAnt && this.minuta.archivosCargadosAnt.length > 0) {
                const archivosAnterioresData = JSON.stringify(this.minuta.archivosCargadosAnt.map(archivo => ({
                    nombreArchivo: archivo.nombreArchivo,
                    url: archivo.url,
                    fecha: archivo.fecha
                })));
                formData.append('archivos_anteriores', archivosAnterioresData);
            }
            // Añadir archivos al FormData 
            this.minuta.archivos.forEach((file, index) => {
                formData.append(`archivo_${index}`, file);
            });

            formData.append('detailsActivities', JSON.stringify(this.minuta.actividades));
            formData.append('recursos', JSON.stringify(this.recursosList));
            formData.append('recursos_anteriores', JSON.stringify(this.recursosLastList));

            try {
                let response;
                if (this.minuta.id === null) {
                    response = await this.$axios.post('createMinuta', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                } else {
                    // Minuta existente - API de edición 
                    formData.append('minuta_id', this.minuta.id);
                    formData.append('nombreReunion', this.minuta.nombreReunion);
                    formData.append('fechaReunion', this.minuta.fechaReunion);
                    formData.append('objetivoReunion', this.minuta.objetivoReunion);
                    formData.append('lugar', this.minuta.lugar);
                    formData.append('convocados', JSON.stringify(this.minuta.convocados));
                    formData.append('agenda', JSON.stringify(this.minuta.agenda));
                    formData.append('actividades', JSON.stringify(this.minuta.actividades));

                    this.minuta.archivos.forEach((file, index) => {
                        formData.append(`archivo_${index}`, file);
                    });
                    response = await this.$axios.post('editMinuta', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                }

                const { iconos, encuesta, minuta_id } = response.data;
                try {
                    this.selectedEvent.minutas[0].id_minuta = minuta_id;
                    this.selectedEvent.minutas[0].fecha_reunion = this.minuta.fechaReunion;
                    this.selectedEvent.minutas[0].estado_minuta = 1;
                } catch (error) {
                    console.log('no se encontro la propuidad');
                }

                if (iconos.includes('mdi-file-alert-outline') && iconos.includes('mdi-presentation') && encuesta === 0 && this.selectedEvent.tipo_evento === 'cliente') {
                    this.encuesta.id_minuta = minuta_id;
                    this.encuesta.enviado_por = this.$store.state.id;
                    this.dialogEncuesta = true;
                }

                // Aquí puedes agregar cualquier acción adicional después de guardar los datos
                this.loadingAddMnt = false;
                this.resetForm();
                this.loadEvents();
            } catch (error) {
                this.loadingAddMnt = false;
                console.error('Error al guardar la minuta:', error);
            }
        },
        sendSurvey() {
            this.loadingSendEncuesta = true;
            this.$axios.post('sendSurvey', this.encuesta)
                .then(response => {
                    this.limpiarEncuesta();
                    this.loadingSendEncuesta = false;
                })
                .catch(error => {
                    console.error(error);
                    this.loadingSendEncuesta = false;
                });
        },
        limpiarEncuesta() {
            this.encuesta = {
                clientes: [],
                id_minuta: '',
                enviado_por: '',
                tipo_encuesta: 'Encuesta simple'
            }
            this.dialogEncuesta = false;
        },
        maxFilesRule(value) {
            return value.length <= this.remainingFiles || `Solo se pueden cargar un máximo de ${this.maxFiles} archivos.`;
        },
        validFileTypeRule(value) {
            return value.every(file => this.validFileTypes.includes(file.type)) || 'Solo se permiten archivos PDF.';
        },
        maxFileSizeRule(value) {
            return value.every(file => file.size <= this.maxSize);
        },
        validateFiles() {
            // Remueve archivos si se excede el límite 
            if (this.minuta.archivos.length > this.remainingFiles) {
                this.minuta.archivos.splice(this.remainingFiles);
            }
        },
        resetForm() {
            this.dialogMinuta = false;
            this.minuta = {
                id: null,
                nombreReunion: '',
                fechaReunion: '',
                lugar: '',
                objetivoReunion: '',
                convocados: [],
                agenda: [],
                archivos: [],
                actividades: [],
                archivosCargados: [],
                archivosCargadosAnt: [],
            };
            this.recursosList = [];
            this.recursosLastList = [];
            this.listaConvocadosPendientes = [];
            this.minutaSeleccionada = null
            this.lastEventPermissions = false;
            this.$refs.datos.reset();

        },
        async cargarConvocados(eventoId) {
            const res = await this.$axios.get('getConvocados/' + eventoId);
            let convocados = res.data.map(item => {
                return {
                    'asistencia': "",
                    'name': item.name,
                    'representante': ""
                }
            });

            this.minuta.convocados = convocados;
        },
        async cargarMinutaAnterior(eventoId) {
            try {
                const response = await this.$axios.post('getMinutaById', { evento_id: eventoId, fecha: this.selectedEvent.start });

                this.lastEventPermissions = true;

                if (response.data.data == null) {
                    this.cargarConvocados(eventoId);
                    return false;
                }

                if (!response.data.status) {
                    this.$toast.error(response.data.msg, {
                        position: "bottom-left",
                        timeout: 3436,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 0.38,
                        showCloseButtonOnHover: true,
                        hideProgressBar: false,
                        closeButton: false,
                        icon: true,
                        rtl: false
                    });

                    this.loadingMnt = false;
                    return true;
                }
                const data = response.data.data;
                this.minuta.nombreReunion = data.minuta.nombre_reunion;
                //this.minuta.fechaReunion = data.minuta.fecha_reunion;
                this.minuta.objetivoReunion = data.minuta.objetivo_reunion;
                this.minuta.lugar = data.minuta.lugar;

                // this.minuta.convocados = data.convocados;
                this.minuta.agenda = data.agenda.map(item => ({ item: item.item }));


                let valores = Object.values(data.actividades);
                for (let i = 0; i < valores.length; i++) {

                    var actividadesDetalle = valores[i]['detalles'].map(item => {
                        var fecha = item[0].split(' - ')[0];
                        var texto = item[0].split(' - ')[1];
                        // return fecha + ' - ' +  texto;
                        return { fecha_compromiso: fecha, texto: texto, fecha_inicio: item[1] };

                    });

                    this.minuta.actividades.push({
                        id: valores[i]['actividad_id'],
                        actividad: valores[i]['actividad'],
                        responsable: valores[i]['dni_responsable'],
                        detalles: actividadesDetalle,
                        fechaInicio: valores[i]['fecha_inicio'],
                        status: valores[i]['status'],
                    });
                }


                let valoresLastRecursos = Object.values(data.recursos);

                for (let i = 0; i < valoresLastRecursos.length; i++) {

                    this.recursosLastList.push({
                        id_minuta: valoresLastRecursos[i]['minuta_id'],
                        nombre: valoresLastRecursos[i]['nombre'],
                        url: valoresLastRecursos[i]['enlace'],
                        fecha_carga: valoresLastRecursos[i]['fecha_carga'],
                    });
                }

                this.dialogMinuta = true;

                const date = new Date();
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexados
                const day = String(date.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;
                this.minuta.fechaReunion = formattedDate;

                this.minuta.archivosCargadosAnt = data.archivos.map(archivo => ({
                    nombreArchivo: archivo.nombre_archivo,
                    url: archivo.enlace,
                    fecha: archivo.fecha_carga
                }));



            } catch (error) {
                this.dialogMinuta = false;
            }

        },
        viewDay({ date }) {
            this.focus = date
            this.type = 'day'
        },
        printDate(day) {
            if (this.selectedOpen) {
                this.selectedOpen = false
                //requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                this.addMeet = true;
                this.form.dateMeet = []
                if (!this.form.dateMeet.includes(day.date)) {
                    this.form.dateMeet.push(day.date);
                }
            }

        },
        getEventColor(event) {
            return event.color
        },
        setToday() {
            this.focus = ''
        },
        prev() {
            this.$refs.calendar.prev()
        },
        next() {
            this.$refs.calendar.next()
        },
        leadersClientsList() {
            let data = this.filteredLeaders.concat(this.filteredClients);
            if (this.disableEditActivities) {
                this.newActivity.responsable = this.$store.state.id
            }
            return data.sort((a, b) => a.name.localeCompare(b.name));
        },
        showEvent({ nativeEvent, event }) {
            this.validateLastMinuta(event.id, event.codigo);

            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                // Filtrar los invitees donde type_invitee es 'interno'
                this.filteredLeaders = this.selectedEvent.invitees.filter(invitee => invitee.type_invitee === 'interno');
                this.filteredClients = this.selectedEvent.invitees.filter(invitee => invitee.type_invitee === 'cliente');

                this.minuta.convocados = this.selectedEvent.invitees.map(invitee => ({
                    name: invitee.id,
                    asistencia: '',
                    representante: ''
                }));
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                //requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        handleMinutaButtonClick(eventId, eventDate, minutaId) {
            const { hasMinuta, isDateEqual, estadoMinuta } = this.hasMinutaForEvent(this.selectedEvent);
            if (this.isCreator || this.isCoCreator) {
                if (hasMinuta && isDateEqual) {
                    // No Disponible - No hacer nada o mostrar un mensaje de error 
                    //console.warn("No se puede editar una minuta futura.");
                    this.getMinuta(eventId, eventDate, minutaId);

                } else if (!hasMinuta || (hasMinuta && !isDateEqual)) {
                    this.loadingMnt = true;
                    this.cargarMinutaAnterior(eventId).then(res => {
                        if (!res) {
                            this.createMinuta(eventId, eventDate, minutaId);
                            this.loadingMnt = false;
                        }
                    });
                } /*else if (!hasMinuta || (hasMinuta && !isDateEqual && !isDateGreater)) { // Crear Minuta 
                    this.createMinuta(eventId, eventDate);
                }*/
            } else {
                /*if (hasMinuta && isDateGreater) {
                    // No Disponible - No hacer nada o mostrar un mensaje de error 
                    console.warn("No se puede ver una minuta futura.");
                } else*/  if (hasMinuta && isDateEqual) {
                    // Ver Minuta 
                    this.getMinuta(eventId, eventDate, minutaId);
                } else {
                    // No Disponible - No hacer nada o mostrar un mensaje de error 
                    console.warn("No hay minuta disponible para ver.");
                }
            }
        },
        hasMinutaForEvent(event) {
            if (!event || !event.start) {
                console.error('Evento o fecha de inicio no definidos:', event);
                return { hasMinuta: false, isDateEqual: false, estadoMinuta: null };
            }
            const eventDate = new Date(event.start).toISOString().split('T')[0];
            if (event.minutas && event.minutas.length > 0) {
                for (let i = 0; i < event.minutas.length; i++) {
                    const minuta = event.minutas[i];
                    const isDateEqual = eventDate === minuta.fecha_reunion;
                    //const isDateGreater = new Date(minuta.fecha_reunion) > new Date(eventDate);

                    if (isDateEqual) {
                        return {
                            hasMinuta: true,
                            isDateEqual: isDateEqual,
                            estadoMinuta: minuta.estado_minuta
                            //isDateGreater: isDateGreater
                        };
                    }
                }
            }

            return { hasMinuta: false, isDateEqual: false, estadoMinuta: null };
            //return false;
            //return event.minuta && eventDate === event.fecha_minuta;
        },
        getButtonLabel() {
            if (!this.selectedEvent || !this.selectedEvent.start) {
                return ''; // O cualquier mensaje predeterminado
            }

            const { hasMinuta, isDateEqual, estadoMinuta } = this.hasMinutaForEvent(this.selectedEvent);

            if (this.isCreator || this.isCoCreator) {
                if (hasMinuta && isDateEqual) { return 'Ver Minuta'; } else { return 'Crear Minuta'; }
            } else {
                if (hasMinuta && isDateEqual) { return 'Ver Minuta'; } else { return 'No Disponible'; }
            }
        },
        getMinutaId(event) {
            if (event.minutas && event.minutas.length > 0) {
                for (let i = 0; i < event.minutas.length; i++) {
                    const minuta = event.minutas[i];
                    const eventDate = new Date(event.start).toISOString().split('T')[0];
                    if (eventDate === minuta.fecha_reunion) {
                        return minuta.id_minuta;
                    }
                }
            }
            return null;
        },
        createMinuta(evento_id, eventDate) {
            this.selectedOpen = false
            // Verificar si eventDate es una fecha válida
            const date = new Date(eventDate);
            if (isNaN(date)) {
                console.error('Fecha inválida:', eventDate);
                return;
            }
            // Formatear la fecha al formato YYYY-MM-DD
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexados
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            this.minuta.fechaReunion = formattedDate;
            this.dialogMinuta = true;
        },
        validateLastMinuta(currentEvent, codigo = null) {

            var codigoSelected = codigo == null ? this.selectedEvent.codigo : codigo;

            let group = this.events.filter(item => item.codigo == codigoSelected && item.minutas[0].id_minuta !== undefined);

            let sortGroup = group.sort(function (a, b) {
                var date1 = new Date(a.start)
                var date2 = new Date(b.start)
                return date1.getTime() - date2.getTime();
            });

            let lastEvent = sortGroup[Object.keys(sortGroup)[Object.keys(sortGroup).length - 1]];

            if (lastEvent == undefined) {
                return false;
            }


            if (currentEvent == lastEvent.id) {
                this.lastEventPermissions = true;
            } else {
                this.lastEventPermissions = false;
            }

            if (lastEvent.minutas[0].estado_minuta == 2) {
                this.lastEventPermissions = false;
            }
        },
        async getMinuta(evento_id, eventDate, minuta_id) {
            this.validateLastMinuta(evento_id);

            this.loadingMnt = true;

            try {
                const response = await this.$axios.post('getMinuta', { evento_id, minuta_id });
                // this.cargarConvocados(evento_id);
                const data = response.data.data[0].fn_sic_obtener_minuta;
                const actividades = response.data.actividades;
                const lastRecursos = response.data.recursos;
                // this.recursosLastList = response.data.recursos;
                //this.loadEvents();
                const parts = data.split('¥');

                this.minuta.id = parts[0]
                this.minuta.nombreReunion = parts[1]
                this.minuta.fechaReunion = parts[2]
                this.minuta.objetivoReunion = parts[3]
                this.minuta.lugar = parts[4]
                this.minuta.agenda = parts[7] ? parts[7].split('‡').map(item => ({ item })) : []

                // Separar convocados actuales e históricos
                this.minuta.convocados = [];
                this.minuta.convocadosHistorial = [];

                if (parts[10] == 2) {
                    this.statusMinuta = false;
                } else {
                    this.statusMinuta = true;
                }
                if (parts[6]) {
                    const convocados = parts[6].split('‡');
                    convocados.forEach(convocado => {
                        const convocadoParts = convocado.split('†');
                        const convocadoObj = {
                            name: convocadoParts[0],
                            asistencia: convocadoParts[1],
                            representante: Number(convocadoParts[2]),
                            minuta_id: convocadoParts[3]
                        };

                        if (convocadoObj.minuta_id == minuta_id) {
                            this.minuta.convocados.push(convocadoObj);
                        } else {
                            this.minuta.convocadosHistorial.push(convocadoObj);
                        }
                    });
                }

                let valores = Object.values(actividades);
                for (let i = 0; i < valores.length; i++) {

                    var actividadesDetalle = valores[i]['detalles'].map(item => {
                        var fecha = item[0].split(' - ')[0];
                        var texto = item[0].split(' - ')[1];
                        return { fecha_compromiso: fecha, texto: texto, fecha_inicio: item[1] };
                    });

                    this.minuta.actividades.push({
                        id: valores[i]['actividad_id'],
                        actividad: valores[i]['actividad'],
                        //responsable: valores[i]['dni_responsable'],
                        responsable: valores[i]['dni_responsable']
                            ? valores[i]['dni_responsable'].split(',')
                            : [],
                        detalles: actividadesDetalle,
                        fechaInicio: valores[i]['fecha_inicio'],
                        status: valores[i]['status'],
                    });
                }

                let valoresLastRecursos = Object.values(lastRecursos);
                for (let i = 0; i < valoresLastRecursos.length; i++) {
                    this.recursosLastList.push({
                        id_minuta: valoresLastRecursos[i]['minuta_id'],
                        nombre: valoresLastRecursos[i]['nombre'],
                        url: valoresLastRecursos[i]['enlace'],
                        fecha_carga: valoresLastRecursos[i]['fecha_carga'],
                    });
                }

                this.minuta.archivosCargados = parts[9] ? parts[9].split('‡').map(archivo => {
                    const archivoParts = archivo.split('†');
                    return {
                        nombreArchivo: archivoParts[0],
                        url: archivoParts[1],
                        fecha: archivoParts[2],
                        antiguedad: archivoParts[3]
                    };
                }) : [];

                this.selectedOpen = false
                this.loadingMnt = false;
                this.dialogMinuta = true
            } catch (error) {
                console.error('Error al guardar los eventos:', error);
                this.loadingMnt = false;
            }

        },
        getInviteeNameLeader(id) {
            const invitee = this.filteredLeaders.find(invitee => invitee.id === id);
            return invitee ? invitee.name : 'Desconocido';
        },
        getInviteeNameAll(id) {
            const invitee = this.selectedEvent.invitees.find(invitee => invitee.id == id);
            return invitee ? invitee.name : 'Desconocido';
        },
        updateRange({ start, end }) {
            const min = new Date(`${start.date}T00:00:00`)
            const max = new Date(`${end.date}T23:59:59`)

            this.events = this.predefinedEvents.filter(event => {
                return event.start >= min && event.end <= max;
            });
        },
        formatDate(date) {
            const options = { weekday: 'long', day: 'numeric', month: 'long' };
            return new Date(date).toLocaleDateString('es-MX', options);
        },
        formatTime(date) {
            const options = { hour: 'numeric', minute: 'numeric', hour12: true };
            return new Date(date).toLocaleTimeString('es-MX', options).replace(' ', '');
        },
        formatEventTime(start, end) {
            return `${this.formatDate(start)}⋅${this.formatTime(start)} – ${this.formatTime(end)}`;
        },
        internosByCampana(campanasList) {
            return this.internos.filter(interno => interno.campanas.some(campana => campanasList.includes(campana.in_CampanaId)));
        },
        //METODO PARA CREAR EVENTOS Y GUARDARLOS EN LA BD
        async createEvent() {
            const organizer = {
                name: this.$store.state.id, // Reemplaza con el nombre del organizador
                role: 'Organizador',
                type: 'interno'
            };

            if (this.detailsMeet.length > 250) {
                this.$toast.error('El maximo de caracteres en el campo detalle es 250');
                return false;
            }
            const getRecurrenceColor = (pattern) => {
                const option = this.recurrenceOptions.find(opt => opt.value === pattern); return option ? option.color : 'red';
            };
            const eventsToSend = this.form.dateMeet.map(date => ({
                name: this.form.title,
                start: `${date}T${this.form.startTime}`,
                end: `${date}T${this.form.endTime}`,
                color: getRecurrenceColor(this.form.recurrence_pattern),
                timed: true,
                details: this.detailsMeet,
                recurrence_pattern: this.form.recurrence_pattern,
                icon: '', // Icono fijo
                type: this.selectedMeetingType,
                campaign: this.form.campana,
                creatorId: this.$store.state.id,
                invitees: [
                    organizer,
                    // ...this.internosByCampana(this.form.campana).filter(item => item.id != this.$store.state.id).map(item => {
                    //     return {
                    //         name: item.id,
                    //         role: 'Organizador',
                    //         type: 'interno'
                    //     }
                    // }),
                    ...this.selectedAttendee.map(attendee => {
                        const tipo = this.internos.find(interno => interno.id === attendee) ? 'interno' : 'cliente';
                        return {
                            name: attendee,
                            role: 'Invitado',
                            type: tipo
                        };
                    })
                ]
            }));
            const payload = {
                data: eventsToSend.map(event =>
                    `${event.name}†${event.start}†${event.end}†${event.color}†${event.timed}†${event.details}†${event.recurrence_pattern}†${event.icon}†${event.type}†${event.campaign}†${event.creatorId}†${event.invitees.map(invitee => `${invitee.name}:${invitee.role}:${invitee.type}`).join(',')}`
                ).join('‡')
            };
            // Enviar eventos al backend
            try {
                this.cancel();
                this.loadingCalendar = true;
                const response = await this.$axios.post('newEvents', payload);

                this.loadEvents();
            } catch (error) {
                console.error('Error al guardar los eventos:', error);
            }
        },
        limpiar() {
            this.form = {
                title: '',
                dateMeet: [],
                recurrence_pattern: '',
                startTime: '',
                endTime: '',
                campana: ''
            },
                this.detailsMeet = null;
            this.selectedMeetingType = null;
            this.selectedAttendee = null;
            this.lastEventPermissions = false;
            this.disableEditActivities = false;
        },
        cancel() {
            this.$refs.datos.reset();
            this.limpiar();
            this.addMeet = false;
        },

        openLink(enlace) {
            window.open(enlace, '_blank');
        },
        async deleteEventCalendar(evento_id) {

            const payload = { 'evento_id': evento_id, 'opcion': this.EventDelete };

            try {
                const response = await this.$axios.post('deleteEvent', payload);
                this.deleteEvent = false;
                this.selectedOpen = false;
                
                this.selectedEvent = {};

                this.loadEvents();
            } catch (error) {
                console.error('Error eliminando el evento:', error);
            }
            this.deleteEvent = false;

        },
        async deleteEventCalendarRecurrence(eventId, date) {
            try {
                const payload = {
                    evento_id: eventId,
                    fecha: date.toISOString().split('T')[0],
                    opcion: this.EventDelete
                };
                if (this.EventDelete === '3') {
                    // Llama al método deleteEventCalendar con el id del evento
                    await this.deleteEventCalendar(eventId);
                    this.deleteEvent = false;
                } else {
                    const response = await this.$axios.post('addEventException', payload);
                    this.loadEvents();
                    this.deleteEvent = false;
                }
            } catch (error) {
                console.error('Error al eliminar el evento:', error);
            }
        },
        async historialAsistencia() {
            this.minuta.convocadosHistorial = []
            this.loadingHistorialasistencias = true;
            this.convocadoshistorialHeader = [{ text: 'Nombre', value: 'name', sortable: false, width: '150px', class: 'text-center' }];

            var convocados = this.minuta.convocados.map(element => element.name);
            const response = await this.$axios.post('/historial/asistencias', { 'minuta_id': this.minuta.id, 'convocados': convocados, 'codigo': this.selectedEvent.codigo });

            if (response.data.status) {
                response.data.fechas.map(item => {
                    this.convocadoshistorialHeader.push({ text: item, value: 'date', sortable: false, width: '100px', class: 'text-center', align: 'center' });
                })

                let historial = response.data.historial.map(item => {
                    let data = {
                        dni_convocado: null,
                        asistencia: []
                    };
                    item.map(elem => {
                        data.dni_convocado = elem.dni_convocado;
                        data.asistencia.push({ fecha: elem.fecha, asistencia: elem.asistencia, representante: elem.representante });
                    })

                    return data;
                })
                this.minuta.convocadosHistorial = historial;
            }
            this.loadingHistorialasistencias = false;

        },
        //METODO PARA TRAER EVENTOS DE LA BD
        async loadEvents(userIdOverride = null) {
            this.loadingCalendar = true;
            try {
                const userId = userIdOverride || this.$store.state.id; // Obtén el ID del usuario desde el store
                const response = await this.$axios.get('events', {
                    params: { userId }
                });
                const { events, exceptions } = response.data;

                //Función para validar y ajustar fechas
                const adjustDateFormat = (dateString) => {
                    // Si la fecha no tiene segundos, añadir ':00'
                    if (dateString.length === 16) {
                        return dateString + ':00';
                    }
                    return dateString;
                };

                // Función para validar fechas
                const isValidDate = (dateString) => {
                    const date = new Date(dateString);
                    return !isNaN(date.getTime());
                };

                // Función para procesar los datos
                const processEventData = (data, exceptions) => {
                    //const exceptionDates = exceptions.map(e => e.fecha);
                    return data.flatMap(item => {
                        if (!item.fn_sic_eventos) {
                            return []; // Ignorar si fn_sic_eventos está vacío
                        }
                        const events = item.fn_sic_eventos.split('‡');
                        return events.flatMap(event => {

                            const [id, name, start, end, color, timed, details, recurrence, icon, fecha_final, tipo_evento, campana, creador_evento, invitees, minutas, codigo, cocreador, est, responsable_act] = event.split('†');
                            // Ajustar el formato de las fechas

                            const adjustedStart = adjustDateFormat(start);
                            const adjustedEnd = adjustDateFormat(end);

                            // Validar fechas
                            if (!isValidDate(adjustedStart) || !isValidDate(adjustedEnd)) {
                                console.error('Fecha inválida:', adjustedStart, adjustedEnd);
                                return []; // Ignorar eventos con fechas inválidas
                            }

                            const inviteesArray = invitees.split(', ').map(inv => {
                                const [inviteeName, inviteeId, role, tipo_invitado] = inv.split(' - ');
                                return { name: inviteeName, id: inviteeId, role: role, type_invitee: tipo_invitado };
                            });
                            // Extraer solo la fecha de adjustedStart
                            //const adjustedStartDate = adjustedStart.split('T')[0];
                            const minutasArray = minutas.split(',').map(minuta => {
                                //const [hasMinuta, fecha_reunion, id_minuta, estado_minuta] = minuta.split('+');
                                const [fecha_reunion, id_minuta, estado_minuta, id_encuesta, respondido_personal, respondido_global] = minuta.split('+');
                                return {
                                    //hasMinuta: hasMinuta === 'true',
                                    fecha_reunion: fecha_reunion ? fecha_reunion : null,
                                    id_minuta: id_minuta,
                                    estado_minuta: estado_minuta,
                                    id_encuesta: id_encuesta !== '0' ? id_encuesta : null,
                                    respondido_personal: parseInt(respondido_personal || 0),
                                    respondido_global: parseInt(respondido_global || 0),
                                };
                            });

                            const baseEvent = {
                                id: id,
                                name: name,
                                start: new Date(adjustedStart),
                                end: new Date(adjustedEnd),
                                color: color,
                                timed: timed === 'true',
                                details: details,
                                recurrence_pattern: recurrence,
                                icon: icon,
                                fecha_final: fecha_final ? new Date(fecha_final) : null,
                                tipo_evento: tipo_evento,
                                campana: campana,
                                creador_evento: creador_evento,
                                invitees: inviteesArray,
                                minutas: minutasArray,
                                responsable_act: responsable_act,
                                codigo: codigo,
                                cocreador: cocreador,
                                estado: est,
                            };

                            // Filtrar excepciones para este evento específico 
                            const eventExceptions = exceptions.filter(e => e.evento_id == id).map(e => e.fecha);

                            // Generar eventos recurrentes
                            const recurringEvents = [];
                            const startDate = new Date(baseEvent.start);
                            //const endOfYear = new Date(startDate.getFullYear(), 11, 31); // 31 de diciembre del mismo año
                            const endDate = baseEvent.fecha_final || new Date(startDate.getFullYear(), 11, 31);

                            // if (recurrence === 'Diaria') {
                            //     const daysUntilEndDate = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
                            //     for (let i = 1; i <= daysUntilEndDate; i++) {
                            //         const recurringEvent = { ...baseEvent };
                            //         recurringEvent.start = new Date(new Date(baseEvent.start).setDate(baseEvent.start.getDate() + i));
                            //         recurringEvent.end = new Date(new Date(baseEvent.end).setDate(baseEvent.end.getDate() + i));
                            //         const recurringEventDate = recurringEvent.start.toISOString().split('T')[0];
                            //         if (!eventExceptions.includes(recurringEventDate)) {
                            //             recurringEvents.push(recurringEvent);
                            //         }
                            //         //recurringEvents.push(recurringEvent);
                            //     }

                            // } else if (recurrence === 'Semanal') {
                            //     const weeksUntilEndDate = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24 * 7));
                            //     for (let i = 1; i <= weeksUntilEndDate; i++) {
                            //         const recurringEvent = { ...baseEvent };
                            //         recurringEvent.start = new Date(new Date(baseEvent.start).setDate(baseEvent.start.getDate() + i * 7));
                            //         recurringEvent.end = new Date(new Date(baseEvent.end).setDate(baseEvent.end.getDate() + i * 7));
                            //         const recurringEventDate = recurringEvent.start.toISOString().split('T')[0];
                            //         if (!eventExceptions.includes(recurringEventDate)) {
                            //             recurringEvents.push(recurringEvent);
                            //         }
                            //     }
                            // } else if (recurrence === 'Mensual') {
                            //     const monthsUntilEndDate = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());
                            //     for (let i = 1; i <= monthsUntilEndDate; i++) {
                            //         const recurringEvent = { ...baseEvent };
                            //         recurringEvent.start = new Date(new Date(baseEvent.start).setMonth(baseEvent.start.getMonth() + i));
                            //         recurringEvent.end = new Date(new Date(baseEvent.end).setMonth(baseEvent.end.getMonth() + i));
                            //         const recurringEventDate = recurringEvent.start.toISOString().split('T')[0];
                            //         if (!eventExceptions.includes(recurringEventDate)) {
                            //             recurringEvents.push(recurringEvent);
                            //         }
                            //     }
                            // }

                            //return baseEvent;
                            return [baseEvent];
                        });
                    })
                };

                // Procesar los datos
                this.predefinedEvents = processEventData(events, exceptions);
                this.events = this.predefinedEvents;

            } catch (error) {
                console.error('Error al cargar los eventos:', error);
            } finally {
                this.loadingCalendar = false; // Finalizar carga
            }
        },
        edit(event) {
        },
        async cerrarMinuta() {
            this.modalCerrarMinuta = false;

            const response = await this.$axios.post('/minuta/close', { 'codigo': this.selectedEvent.codigo });
            if (!response.data.status) {
                this.$toast.error(response.data.msg, {
                    position: "bottom-left",
                    timeout: 8000,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
                return false;
            }
            this.loadEvents();
            this.resetForm();
        },
        reabrirMinuta() {
            this.dialogConfirmReabrir = true;
        },
        async ejecutarReabrirMinuta() {

            this.cargandoReapertura = true;

            try {
                const response = await this.$axios.post('/minuta/reopen', {
                    'codigo': this.selectedEvent.codigo
                });

                if (response.data.status) {
                    await this.loadEvents();
                    const eventoFresco = this.events.find(e => e.codigo === this.selectedEvent.codigo);

                    if (eventoFresco) {
                        this.selectedEvent = Object.assign({}, eventoFresco);

                        this.statusMinuta = true;
                        this.lastEventPermissions = true;

                        if (this.minuta) {
                            this.minuta.estado_minuta = 1;
                        }
                    }
                    this.dialogConfirmReabrir = false;
                    this.$toast.success('Minuta habilitada para editar');
                } else {
                    this.$toast.error(response.data.msg);
                }
            } catch (error) {
                console.error("Error al reabrir:", error);
                this.$toast.error('No se pudo reabrir la minuta');
            } finally {
                this.cargandoReapertura = false;
            }
        },
        exportarMinuta(formato) {
            const eventoId = this.selectedEvent.id;
            const minutaId = this.getMinutaId(this.selectedEvent); // <--- Usamos tu función

            if (!minutaId) {
                this.$toast.error("No se pudo obtener el ID de la minuta");
                return;
            }

            const baseUrl = this.$axios.defaults.baseURL;

            const url = `${baseUrl}minuta/exportar/${formato}?evento_id=${eventoId}&minuta_id=${minutaId}`;

            window.open(url, '_blank');
        },
        Encuesta(minuta, evento) {
            this.selectedSurvey = {
                id: minuta.id_encuesta,
                id_minuta: minuta.id_minuta,
                nombre_reunion: evento.name, // El nombre viene del evento del calendario
                fecha_reunion: minuta.fecha_reunion
            };

            this.dialogEvaluar = true;
        },
        esFechaValida(fechaReunion) {
            if (!fechaReunion) return false;

            const fecha = new Date(fechaReunion);
            const hoy = new Date();
            const diferenciaDias = (hoy - fecha) / (1000 * 60 * 60 * 24);

            // Retorna true si la reunión fue hace 7 días o menos, y no es una fecha futura
            return diferenciaDias >= 0 && diferenciaDias <= 7;
        },
        //METODOS PRIVILEGIO DE NIVEL 6
        cambiarVistaUsuario(idSeleccionado) {
            if (!idSeleccionado) {
                this.restablecerMiCalendario();
                return;
            }
            this.userViewing = this.userSelected;

            //console.log("Buscando eventos para el ID:", idSeleccionado);
            this.loadEvents(idSeleccionado);
        },
        restablecerMiCalendario() {
            this.userSelected = null;
            this.campanaFiltro = null;
            this.userViewing = null;
            this.loadEvents(this.$store.state.id);
        },
        intentarCrearEvento(date) {
            if (this.userViewing) {
                this.$toast.error('Estás en modo lectura, no puedes crear eventos aquí.');
                return; // Detenemos la ejecución
            }

            if (this.Rol !== '39') {
                this.printDate(date);
            }
        },
        hasEncuestaForEvent(event) {
            if (!event || !event.minutas || event.minutas.length === 0) {
                return { hasEncuesta: false };
            }
            const minuta = event.minutas[0];
            // El botón se activa solo si el cliente ya respondió (respondido: 1)
            return {
                hasEncuesta: minuta.respondido_global === 1,
                idMinuta: minuta.id_minuta
            };
        },
        async abrirModalEncuesta(event) {
            const info = this.hasEncuestaForEvent(event);
            if (!info.idMinuta) return;

            this.dialogVerEncuesta = true;
            this.cargandoEncuestas = true;
            this.listaEncuestas = [];

            try {
                // Llamada al API pasándole el ID de la minuta
                const response = await this.$axios.get(`minuta/calificaciones-detalle/${info.idMinuta}`);

                if (response.data) {
                    // Asumiendo que el API devuelve un array de objetos
                    this.listaEncuestas = response.data;
                }
            } catch (error) {
                console.error("Error al obtener detalle:", error);
                this.$toast.error("No se pudo cargar el detalle de las calificaciones");
            } finally {
                this.cargandoEncuestas = false;
            }
        },
        validarHoras() {
            // 1. Validar Hora de Inicio
            if (this.form.startTime) {
                const [hStart, mStart] = this.form.startTime.split(':').map(Number);

                if (hStart > 23 || mStart > 59 || isNaN(hStart) || isNaN(mStart)) {
                    this.$toast.error('Hora de inicio inválida');
                    this.$nextTick(() => { this.form.startTime = ''; }); // Limpieza forzada
                    return;
                }

                // Autocompletado inteligente
                if (!this.form.endTime) {
                    let hEnd = (hStart + 1) % 24;
                    this.form.endTime = `${hEnd.toString().padStart(2, '0')}:${mStart.toString().padStart(2, '0')}`;
                }
            }

            // 2. Validar Hora de Fin
            if (this.form.endTime) {
                const [hEnd, mEnd] = this.form.endTime.split(':').map(Number);

                if (hEnd > 23 || mEnd > 59 || isNaN(hEnd) || isNaN(mEnd)) {
                    this.$toast.error('Hora de fin inválida');
                    this.$nextTick(() => { this.form.endTime = ''; }); // Limpieza forzada
                    return;
                }
            }

            // 3. Comparación de rangos
            if (this.form.startTime && this.form.endTime) {
                const startTotal = parseInt(this.form.startTime.replace(':', ''));
                const endTotal = parseInt(this.form.endTime.replace(':', ''));

                if (endTotal <= startTotal) {
                    this.$toast.warning('La hora de fin debe ser posterior al inicio');
                    this.$nextTick(() => { this.form.endTime = ''; }); // Limpieza forzada
                }
            }
        }
    },


    created() {
    },
}
export default meeting